import firebase from "firebase/compat/app";
import "firebase/compat/functions";

const getFunctions = () => firebase.app().functions("us-central1");

/**
 * Persist the medrec-intake reconciled-list artifact onto the conversation
 * session. `reconciledList` must match docs/MEDREC_INTAKE_OUTPUT_SCHEMA.md.
 */
export async function saveReconciledMedications({ sessionId, reconciledList }) {
  const callable = getFunctions().httpsCallable("saveReconciledMedications");
  const result = await callable({ sessionId, reconciledList });
  return result.data;
}

/**
 * Role-gated read of the reconciled-list artifact for the FDE-C annotation UI
 * and any downstream CMR sync. Returns { sessionId, tciId, reconciledMedications }.
 */
export async function getReconciledMedications(sessionId) {
  const callable = getFunctions().httpsCallable("getReconciledMedications");
  const result = await callable({ sessionId });
  return result.data;
}

/**
 * Promote a session's reconciled-list artifact directly into the patient's CMR
 * medication list (CB-1). Mode (patient-solo vs. clinician-assisted) and
 * per-entry provenance are derived server-side from the authenticated caller.
 * Returns { status, patientUserId, provenance, added, updated, removed, skipped }.
 */
export async function syncReconciledMedicationsToCmr(sessionId) {
  const callable = getFunctions().httpsCallable("syncReconciledMedicationsToCmr");
  const result = await callable({ sessionId });
  return result.data;
}

/**
 * Run registered TCI product-surface adapters for a session (e.g. CMR med list).
 */
export async function dispatchProductSurfaces({ sessionId, tciId } = {}) {
  const callable = getFunctions().httpsCallable("dispatchProductSurfaces");
  const result = await callable({ sessionId, tciId });
  return result.data;
}
